/**
 * The graphql endpoint details.
 *
 * The endpoint can include a path with `__opname__`, which
 * will be replaced by the query's operation-name at query-time.
 * See services/fastly-khanacademy-compute/handlers/graphql.go.
 */
export const getGqlEndpoint = (): string => "/api/internal/graphql/__opname__";
